import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import _, { set } from 'lodash'
import { useIntl } from 'react-intl'
import { Fieldset } from 'primereact/fieldset'
import { Divider } from 'primereact/divider'
import { useParams } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { Checkbox } from 'primereact/checkbox'
import { Container, Group, Stack } from '@mantine/core'
import CompaniesService from '../../../../services/companies/companies.service'
import UsersService from '../../../../services/users/users.service'
import { ACTIVITY_TYPES } from '../../../../utils/constants/activityTypes'
import { ZONES } from '../../../../utils/constants/zones'
import LabeledDropdown from '../../../../components/common/form-components/labeled-dropdown/LabeledDropdown'
import LabeledCheckbox from '../../../../components/common/form-components/labeled-checkbox/LabeledCheckbox'
import LabeledText from '../../../../components/common/form-components/labeled-inputs/LabeledText'
import useInputs from '../../../../utils/hooks/useInputs'
import CenterService from '../../../../services/centers/center.service'

import './centerForm.scss'
import { CENTER_TYPES } from '../../../../utils/constants/centerTypes'
import swalAlert from '../../../../utils/helpers/swalAlert'
import DropdownComp from '../../../../components/common/form-components/dropdown/DropdownComp'
import DataTableComp from '../../../../components/common/data-table/DataTableComp'
import useHandlerBasicActions from '../../../../utils/hooks/useHandlerBasicActions'
import Modal from '../../../../components/modal/Modal'
import useModal from '../../../../utils/hooks/useModal'
import AddButton from '../../../../components/common/buttons/AddButton'
import CenterTechnicsTrackForm from './CenterTechnicsTrackForm'
import CenterTechnicsOtherForm from './CenterTechnicsOtherForm'
import CenterTechnicsAspiratorForm from './CenterTechnicsAspiratorForm'
import CenterSettingsService from '../../../../services/settings/centers/centerSettings.service'
import CheckboxCom from '../../../../components/common/form-components/checkbox/CheckboxComp'
import AppContainer from '../../../../component/layout/AppContainer.tsx'
import AppSimpleGrid from '../../../../component/layout/AppSimpleGrid.tsx'
import AppInput from '../../../../component/form/AppInput.tsx'
import EntityDropdown from '../../../../component/form/EntityDropdown.tsx'
import AppCheckbox from '../../../../component/form/AppCheckbox.tsx'
import AppToolbar from '../../../../component/layout/AppToolbar.tsx'
import AppHeaderView from '../../../../component/layout/AppHeaderView.tsx'
import AppButton from '../../../../component/common/AppButton.tsx'
import AppModal from '../../../../component/layout/AppModal.tsx'
import { useDisclosure } from '@mantine/hooks'

const CenterTechnicsForm = ({
  centerId,
  inputs,
  onChangeInputs,
  updateInputs,
}) => {
  const { t } = useTranslation()

  const [opened, { open, close }] = useDisclosure(false)

  const { formatMessage: msg } = useIntl()

  const [selectedItem, setSelectedItem] = useState()
  const [currentDataToShow, setCurrentDataToShow] = useState('aspirators')

  // const toggleAndReset = () => {
  //   setSelectedItem()
  //   toggle()
  // }

  const renderBool = (checked) => {
    return <CheckboxCom disabled checked={checked === true} />
  }

  const dataColumns = {
    aspirators: [
      <Column
        sortable
        field="aspiratorTypes.name"
        header={msg({ id: 'name' })}
      />,
      <Column
        sortable
        field="aspiratorTypes.name"
        header={msg({ id: 'description' })}
      />,
      <Column
        sortable
        field="hyprocash"
        align="right"
        style={{ width: 120, maxWidth: 120 }}
        header={msg({ id: 'hyprocash' })}
        body={(rowData) => renderBool(rowData?.hyprocash)}
      />,
      <Column
        sortable
        field="stopAndGo"
        align="right"
        style={{ width: 120, maxWidth: 120 }}
        header={msg({ id: 'stopAndGo' })}
        body={(rowData) => renderBool(rowData?.stopAndGo)}
      />,
      <Column
        sortable
        field="aspiratorTypes.active"
        align="right"
        style={{ width: 120, maxWidth: 120 }}
        header={msg({ id: 'active' })}
        body={(rowData) => renderBool(rowData?.aspiratorTypes?.active)}
      />,
    ],
    tracks: [
      <Column
        sortable
        field="trackTypes.name"
        header={msg({ id: 'trackType' })}
        body={(rowData) =>
          rowData?.trackTypes?.name
            ?.concat(' - ')
            .concat(rowData?.trackTypes?.description)
        }
      />,
      <Column
        sortable
        field="plattenTypes.name"
        header={msg({ id: 'plattenType' })}
        body={(rowData) =>
          rowData?.plattenTypes?.name
            ?.concat(' - ')
            .concat(rowData?.plattenTypes?.description)
        }
      />,
      <Column
        sortable
        field="hyprocash"
        align="right"
        style={{ width: 120, maxWidth: 120 }}
        header={msg({ id: 'hyprocash' })}
        body={(rowData) => renderBool(rowData?.hyprocash)}
      />,
      <Column
        sortable
        field="stopAndGo"
        align="right"
        style={{ width: 120, maxWidth: 120 }}
        header={msg({ id: 'stopAndGo' })}
        body={(rowData) => renderBool(rowData?.stopAndGo)}
      />,
    ],
    others: [
      <Column sortable field="model" header={msg({ id: 'model' })} />,
      <Column sortable field="brand" header={msg({ id: 'brand' })} />,
      <Column sortable field="capacity" header={msg({ id: 'capacity' })} />,
      <Column
        sortable
        field="observations"
        header={msg({ id: 'observations' })}
      />,
    ],
  }

  const editFormTitle = {
    aspirators: t('center.technics.aspirators.add'),
    tracks: t('center.technics.tracks.add'),
    others: t('center.technics.others.add'),
  }
  const editForm = {
    aspirators: (
      <CenterTechnicsAspiratorForm
        centerId={centerId}
        selectedItem={selectedItem}
        close={close}
        updateInputs={updateInputs}
      />
    ),
    tracks: (
      <CenterTechnicsTrackForm
        centerId={centerId}
        selectedItem={selectedItem}
        close={close}
        updateInputs={updateInputs}
      />
    ),
    others: (
      <CenterTechnicsOtherForm
        centerId={centerId}
        selectedItem={selectedItem}
        close={close}
        updateInputs={updateInputs}
      />
    ),
  }

  return (
    <AppSimpleGrid cols={2}>
      <AppContainer>
        <Stack>
          <AppSimpleGrid cols={3} breakpoint="xl">
            <AppInput
              label="filterCartridge"
              name="filterCartridge"
              value={inputs?.filterCartridge}
              onChange={onChangeInputs}
            />
            <AppInput
              label="osmosisPlate"
              name="osmosisPlate"
              value={inputs?.osmosisPlate}
              onChange={onChangeInputs}
            />
            <AppInput
              label="MSReader"
              name="MSReader"
              value={inputs?.MSReader}
              onChange={onChangeInputs}
            />
          </AppSimpleGrid>

          <AppSimpleGrid cols={3} breakpoint="xl">
            <AppInput
              label="cisternBufferTank"
              name="cisternBufferTank"
              value={inputs?.cisternBufferTank}
              onChange={onChangeInputs}
            />
            <AppInput
              label="osmosisTankCapacity"
              name="osmosisTankCapacity"
              value={inputs?.osmosisTankCapacity}
              onChange={onChangeInputs}
            />
            <AppInput
              label="boilerYear"
              name="boilerYear"
              value={inputs?.boilerYear}
              onChange={onChangeInputs}
            />
          </AppSimpleGrid>

          <AppSimpleGrid cols={2} breakpoint="xl">
            <AppInput
              label="boilerPower"
              name="boilerPower"
              value={inputs?.boilerPower}
              onChange={onChangeInputs}
            />
            <AppInput
              label="boilerFan"
              name="boilerFan"
              value={inputs?.boilerFan}
              onChange={onChangeInputs}
            />
          </AppSimpleGrid>

          <AppSimpleGrid cols={3} breakpoint="xl">
            <EntityDropdown
              entity="soap"
              label="soapType"
              name="soapTypesId"
              value={inputs?.soapTypesId}
              onChange={onChangeInputs}
            />
            <EntityDropdown
              entity="gas"
              label="gasType"
              name="gasTypesId"
              value={inputs?.gasTypesId}
              onChange={onChangeInputs}
            />
            <EntityDropdown
              entity="heater"
              label="heaterType"
              name="heaterTypesId"
              value={inputs?.heaterTypesId}
              onChange={onChangeInputs}
            />
          </AppSimpleGrid>

          <Divider my="xl" />

          <AppSimpleGrid cols={3} breakpoint="xl">
            <AppCheckbox
              entity="floorHeating"
              size="lg"
              label="floorHeating"
              name="floorHeating"
              checked={inputs?.floorHeating}
              onChange={onChangeInputs}
            />
            <AppCheckbox
              entity="antiIceRecovery"
              size="lg"
              label="antiIceRecovery"
              name="antiIceRecovery"
              checked={inputs?.antiIceRecovery}
              onChange={onChangeInputs}
            />
          </AppSimpleGrid>
        </Stack>
      </AppContainer>

      <DataTableComp
        tableOptions={{
          header: (
            <AppToolbar
              leftSection={[
                <EntityDropdown
                  clearable={false}
                  entity="technics"
                  value={currentDataToShow}
                  onChange={({ value }) => setCurrentDataToShow(value)}
                />,
              ]}
              rightSection={[
                <AppButton
                  preset="add"
                  disabled={!currentDataToShow}
                  onClick={open}
                />,
              ]}
            />
          ),
          value: inputs?.[currentDataToShow],
          dataKey: '_id',
          editMode: 'row',
          selectionMode: 'single',
          selection: selectedItem,
          onRowSelect: (e) => {
            setSelectedItem(e?.data)
            open()
          },
        }}
        columns={dataColumns[currentDataToShow]}
      />

      <AppModal
        opened={opened}
        close={close}
        title={editFormTitle[currentDataToShow]}
      >
        {editForm[currentDataToShow]}
      </AppModal>
    </AppSimpleGrid>
  )
}

export default CenterTechnicsForm
